howspace.fullscreen = (() => {
    'use strict';

    const openFullScreen = elem => {
        elem = howspace.getDOMElement(elem);
        if (!elem) {
            // An empty jQuery set unwraps to undefined, e.g. a selector that matched nothing.
            return;
        }
        if (elem.classList.contains('fullscreen')) {
            // Element is already in fullscreen mode.
            return;
        }

        document.body.classList.add('fullscreen');
        elem.classList.add('fullscreen');

        if (typeof elem.requestFullscreen === 'function') {
            // Browser supports the fullscreen API.
            elem.requestFullscreen().then(() => {
                howspace.dispatchEvent(elem, howspace.fullscreen.FULLSCREEN_OPENED);
            });
            return;
        }

        // Browser does not support the fullscreen API. Use popover fallback instead.
        if (howspace.isFeatureSupported('popover')) {
            elem.setAttribute('popover', 'manual');
            elem.showPopover();
            howspace.dispatchEvent(elem, howspace.fullscreen.FULLSCREEN_OPENED);
        }
    };

    const closeFullScreen = elem => {
        elem = howspace.getDOMElement(elem);
        if (!elem) {
            return;
        }
        if (!elem.classList.contains('fullscreen')) {
            // Element is not in fullscreen mode.
            return;
        }

        document.body.classList.remove('fullscreen');
        elem.classList.remove('fullscreen');

        if (typeof document.exitFullscreen === 'function' && document.fullscreenElement) {
            // Browser supports the fullscreen API.
            document.exitFullscreen().then(() => {
                howspace.dispatchEvent(elem, howspace.fullscreen.FULLSCREEN_CLOSED);
            });
            return;
        }

        // Browser does not support the fullscreen API. Use popover fallback instead.
        if (howspace.isFeatureSupported('popover')) {
            elem.hidePopover();
            elem.removeAttribute('popover');
            howspace.dispatchEvent(elem, howspace.fullscreen.FULLSCREEN_CLOSED);
        }
    }

    document.documentElement.addEventListener('fullscreenchange', () => {
        if (document.fullscreenElement) {
            document.body.classList.add('fullscreen');
        } else {
            document.body.classList.remove('fullscreen');
            const fullScreenElem = document.body.querySelector('.fullscreen');
            if (fullScreenElem) {
                fullScreenElem.classList.remove('fullscreen');
                howspace.dispatchEvent(fullScreenElem, howspace.fullscreen.FULLSCREEN_CLOSED);
            }
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || document.fullscreenElement) {
            return;
        }
        const fullScreenElem = document.body.querySelector('.fullscreen');
        if (fullScreenElem) {
            closeFullScreen(fullScreenElem);
        }
    });

    return {
        FULLSCREEN_OPENED: 'howspace-fullscreen-opened',
        FULLSCREEN_CLOSED: 'howspace-fullscreen-closed',
        toggle: elem => {
            elem = howspace.getDOMElement(elem);
            if (!elem) {
                return;
            }
            if (elem.classList.contains('fullscreen')) {
                return closeFullScreen(elem);
            } else {
                return openFullScreen(elem);
            }
        },
        open: openFullScreen,
        close: closeFullScreen,
    };

})();
